const cSingleJobInit = () => {

    const jobForms = document.querySelectorAll("._form_13")

    jobForms.forEach(form => {
        const jobName = document.querySelector(".article-h1")
        const jobField = form.querySelector("[data-name='applied_job']")

        jobField.value = jobName.textContent
        
    })
};

export default cSingleJobInit
